// extracted by mini-css-extract-plugin
export default {"cardsGroup":"CardsGroup_cardsGroup__mMORw","title":"CardsGroup_title__MjJx1","list":"CardsGroup_list__Jb9BF"};